module.exports = "<div class=\"celect__options-container\">\n  <celect-option ng-click=\"$ctrl.handleSelect(option, $event)\" ng-value=\"option.value\" ng-selected=\"option.selected\" ng-repeat=\"option in $ctrl.options\">{{option.label}}</celect-option>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/components/celect/celect.html
// module id = 303
// module chunks = 0